var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"a1"}},[(!_vm.isExchange)?_c('handicapGeneral',{attrs:{"prod_code":_vm.code,"throttle":_vm.throttle}}):_c('handicapExchange',{attrs:{"prod_code":_vm.code,"throttle":_vm.throttle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }